import React from 'react';
import BubbleNavigation from '../BubbleUI/BubbleNavigation';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';
import { resolveLibrariesPath } from '@go-client/routes';

export function LibrariesSubNavigation(props: {
  active: 'events' | 'venues' | 'content' | 'staff';
}) {
  const { activeProperty: property } = useActiveProperty();

  return (
    <BubbleNavigation
      appearance="squared"
      items={[
        {
          name: 'Events',
          to: resolveLibrariesPath(property._id, 'events'),
          active: props.active === 'events',
          variant: 'titanium',
        },
        {
          name: 'Venues',
          to: resolveLibrariesPath(property._id, 'venues'),
          active: props.active === 'venues',
          variant: 'titanium',
        },
        {
          name: 'Content',
          to: resolveLibrariesPath(property._id, 'content'),
          active: props.active === 'content',
          variant: 'titanium',
        },
        {
          name: 'Staff',
          to: resolveLibrariesPath(property._id, 'staff'),
          active: props.active === 'staff',
          variant: 'titanium',
        },
      ]}
    />
  );
}
